<template lang='pug'>
  v-layout(align-start)
    v-flex
      v-data-table.elevation-1(:headers='headers', :items='data' :search='search' sort-by='codigo' :loading='loading' loading-text='Cargando, por favor espere...')
        template(v-slot:top)
          v-toolbar(flat color='primary' dark)
            v-flex(class="d-flex flex-wrap justify-center")
              v-toolbar-title Ejecucion Estrategica
              v-divider.mx-4(inset vertical)
              v-spacer
              v-text-field.text-xs-center(v-model='search' label='Busqueda' single-line hide-details color='success')
            v-spacer
            v-dialog(v-model='dialog' scrollable persistent content-class="flex xs12 sm12")
              template(v-slot:activator='{ on }')
                v-btn.mx-2(fab dark small color='success' v-on='on')
                  v-icon(dark) mdi-plus
              v-card(style='padding: 1em')
                v-card-text
                  v-row(dense, justify='space-between')
                    v-col(cols='4')
                      v-autocomplete(
                        autocomplete='off',
                        outlined,
                        dense,
                        v-model='form.idCliente',
                        :items="clientes",
                        label='Cliente',
                        :readonly='editedIndex > -1')
                    v-col(cols='3' v-if='editedIndex > -1')
                      v-text-field(
                        outlined,
                        dense,
                        v-model='form.idUsuario.nombre',
                        label='Usuario',
                        :readonly='true')
                    v-col(cols='3' v-if='editedIndex > -1')
                      v-text-field(
                        outlined,
                        dense,
                        v-model='form.fechaRegistro',
                        label='Fecha',
                        :readonly='true')
                  v-row(dense)
                    v-col(cols='12')
                      v-data-table.table-marcas.elevation-1.rounded-lg(:headers='headersEjecucion', :items='form.marcas')
                        //- Inventario Principal
                        template(v-slot:item.mueblePrincipal='{ item }')
                          v-text-field(
                            :readonly='item.isDisablePrincipal || editedIndex > -1',
                            type='number',
                            @input='changeInventario(item, "principal")',
                            :filled='!item.isDisablePrincipal',
                            v-model.number='item.medidaMueblePrincipal',
                            min='0',
                            style='width: 125px',
                            dense)
                            template(v-slot:prepend)
                              v-icon(:color='!item.isDisablePrincipal ? "primary" : "" ', @click='activate(item, "principal")') mdi-check-bold
                        template(v-slot:item.inventarioPrincipal='{ item }')
                          v-text-field(
                            :readonly='item.isDisablePrincipal || editedIndex > -1',
                            @input='changeInventario(item, "principal")',
                            type='number',
                            :filled='!item.isDisablePrincipal',
                            v-model.number='item.medidaInventarioPrincipal',
                            min='0',
                            style='width: 125px',
                            dense)
                        template(v-slot:item.porcentajeOcupacionPrincipal='{ item }')
                          v-chip(:color='!item.isDisablePrincipal ? "#90CAF9" : ""')
                            | {{ item.porcentajeOcupacionPrincipal }}
                        template(v-slot:item.objetivoPrincipal='{ item }')
                          v-text-field(
                            :readonly='item.isDisablePrincipal || editedIndex > -1',
                            type='number',
                            :filled='!item.isDisablePrincipal',
                            v-model.number='item.objetivoPrincipal',
                            min='0',
                            style='width: 125px',
                            dense)
                        //- Inventario Secundario
                        template(v-slot:item.muebleSecundario='{ item }')
                          v-text-field(
                            :readonly='item.isDisableSecundario || editedIndex > -1',
                            @input='changeInventario(item, "secundario")',
                            type='number',
                            :filled='!item.isDisableSecundario',
                            v-model.number='item.medidaMuebleSecundario',
                            min='0',
                            style='width: 125px',
                            dense)
                            template(v-slot:prepend)
                              v-icon(:color='!item.isDisableSecundario ? "primary" : "" ', @click='activate(item, "secundario")') mdi-check-bold
                        template(v-slot:item.inventarioSecundario='{ item }')
                          v-text-field(
                            :readonly='item.isDisableSecundario || editedIndex > -1',
                            @input='changeInventario(item, "secundario")',
                            type='number',
                            :filled='!item.isDisableSecundario',
                            v-model.number='item.medidaInventarioSecundario',
                            style='width: 125px',
                            dense)
                        template(v-slot:item.porcentajeOcupacionSecundario='{ item }')
                          v-chip(:color='!item.isDisableSecundario ? "#80CBC4" : ""')
                            | {{ item.porcentajeOcupacionSecundario }}
                        template(v-slot:item.objetivoSecundario='{ item }')
                          v-text-field(
                            :readonly='item.isDisableSecundario || editedIndex > -1',
                            type='number',
                            :filled='!item.isDisableSecundario',
                            v-model.number='item.objetivoSecundario',
                            min='0',
                            style='width: 125px',
                            dense)
                v-card-actions
                  v-spacer
                  v-btn(color='error' small='' dark='' @click='close')
                    v-icon mdi-close
                    | Cancelar
                  v-btn(v-if='editedIndex === -1' color='success' small='' dark='' @click='save')
                    v-icon mdi-content-save
                    | Guardar
        template(v-slot:item.action='{ item }')
          v-tooltip(bottom)
            template(v-slot:activator='{ on }')
              v-icon.mr-2(color='primary_2' @click='editItem(item)' v-on="on") mdi-eye
            | Visualizar
          v-tooltip(bottom)
            template(v-slot:activator='{ on }')
              v-icon(color='error' @click='deleteItem(item)' v-on="on") mdi-delete
            | Eliminar
</template>

<script>
import Api from '@/services/methods'
export default {
  data: () => ({
    data: [],
    search: '',
    editedIndex: -1,
    dialog: false,
    loading: false,
    headers: [
      { text: 'Usuario', value: 'idUsuario.nombre', align: 'left', sortable: false },
      { text: 'Fecha', value: 'fechaRegistro', align: 'left', sortable: false },
      { text: 'Cliente', value: 'idCliente.nombre', align: 'left', sortable: false },
      { text: 'Acciones', value: 'action', align: 'right', sortable: false }
    ],
    headersEjecucion: [
      { text: 'Nombre', value: 'marca.nombre', align: 'left', sortable: false, class: 'header-marca' },
      { text: 'Mueble \n Principal (mts)', value: 'mueblePrincipal', sortable: false, class: 'header-principal header-principal__left' },
      { text: 'Marca (mts)', value: 'inventarioPrincipal', sortable: false, class: 'header-principal' },
      { text: '% Ocupacion', value: 'porcentajeOcupacionPrincipal', sortable: false, class: 'header-principal' },
      { text: '%Objetivo', value: 'objetivoPrincipal', sortable: false, class: 'header-principal' },
      { text: 'Mueble \n Secundario (mts)', value: 'muebleSecundario', sortable: false, class: 'header-secundario header-principal__left' },
      { text: 'Marca (mts)', value: 'inventarioSecundario', sortable: false, class: 'header-secundario' },
      { text: '% Ocupacion', value: 'porcentajeOcupacionSecundario', sortable: false, class: 'header-secundario ' },
      { text: '% Objetivo', value: 'objetivoSecundario', sortable: false, class: 'header-principal last-child' }
    ],
    form: {
      idCliente: '',
      marcas: [],
      idUsuario: ''
    },
    defaultForm: {
      idCliente: '',
      marcas: [],
      idUsuario: ''
    },
    clientes: [],
    marcas: []
  }),

  created () {
    this.initialize()
  },

  methods: {

    initialize () {
      this.getClientes()
      this.getMarcas()
      this.getEjecuciones()
    },

    activate (item, mueble) {
      if (this.editedIndex > -1) return null
      const marca = item
      if (mueble === 'principal') {
        if (!marca.isDisablePrincipal && (marca.medidaMueblePrincipal > 0 || marca.medidaInventarioPrincipal > 0)) {
          this.$swal({
            icon: 'info',
            title: '¿Seguro que quieres desactivar?',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, desactivar',
            cancelButtonText: 'cancelar'
          }).then(result => {
            if (result.value) {
              marca.isDisablePrincipal = true
              marca.medidaMueblePrincipal = 0
              marca.medidaInventarioPrincipal = 0
              marca.porcentajeOcupacionPrincipal = '0%'
            }
          })
        } else {
          marca.isDisablePrincipal = !marca.isDisablePrincipal
        }
      } else {
        if (!marca.isDisableSecundario && (marca.medidaMuebleSecundario > 0 || marca.medidaInventarioSecundario > 0)) {
          this.$swal({
            icon: 'info',
            title: '¿Seguro que quieres desactivar?',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, desactivar',
            cancelButtonText: 'cancelar'
          }).then(result => {
            if (result.value) {
              marca.isDisableSecundario = true
              marca.medidaMuebleSecundario = 0
              marca.medidaInventarioSecundario = 0
              marca.porcentajeOcupacionSecundario = '0%'
            }
          })
        } else {
          marca.isDisableSecundario = !marca.isDisableSecundario
        }
      }
      const index = this.form.marcas.find(c => c.marca === marca.marca)
      this.form.marcas[index] = { ...marca }
    },

    changeInventario (item, mueble) {
      if (mueble === 'principal') {
        console.log(item)
        if (item.medidaMueblePrincipal > 0 && item.medidaInventarioPrincipal > 0 && item.medidaInventarioPrincipal <= item.medidaMueblePrincipal) {
          const porcentaje = (item.medidaInventarioPrincipal / item.medidaMueblePrincipal) * 100
          item.porcentajeOcupacionPrincipal = `${Number.parseFloat(porcentaje).toFixed(2)} %`
        } else if (item.medidaMueblePrincipal === '' || item.medidaMueblePrincipal < 0 || item.medidaInventarioPrincipal === '' || item.medidaInventarioPrincipal < 0 || item.medidaInventarioPrincipal > item.medidaMueblePrincipal) {
          item.porcentajeOcupacionPrincipal = 'error con cantidades'
        } else {
          item.porcentajeOcupacionPrincipal = '0%'
        }
      } else {
        if (item.medidaMuebleSecundario > 0 && item.medidaInventarioSecundario > 0 && item.medidaInventarioSecundario <= item.medidaMuebleSecundario) {
          const porcentaje = (item.medidaInventarioSecundario / item.medidaMuebleSecundario) * 100
          item.porcentajeOcupacionSecundario = `${Number.parseFloat(porcentaje).toFixed(2)} %`
        } else if (item.medidaMuebleSecundario === '' || item.medidaMuebleSecundario < 0 || item.medidaInventarioSecundario === '' || item.medidaInventarioSecundario < 0 || item.medidaInventarioSecundario > item.medidaMuebleSecundario) {
          item.porcentajeOcupacionSecundario = 'error con cantidades'
        } else {
          item.porcentajeOcupacionSecundario = '0%'
        }
      }
      const index = this.form.marcas.find(c => c.marca === item.marca)
      this.form.marcas[index] = { ...item }
    },

    getClientes () {
      Api.get('/cliente')
        .then(response => {
          console.log(response)
          if (response.data.length >= 0) {
            response.data.forEach(cliente => {
              this.clientes.push({
                value: { _id: cliente._id, nombre: cliente.nombre },
                text: cliente.nombre
              })
            })
          }
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    getMarcas () {
      Api.get('marca')
        .then(response => {
          response.data.forEach(marca => {
            this.marcas.push({
              marca: { _id: marca._id, nombre: marca.nombre },
              medidaInventarioPrincipal: 0,
              isDisablePrincipal: true,
              medidaMueblePrincipal: 0,
              porcentajeOcupacionPrincipal: '0%',
              objetivoPrincipal: 0,
              medidaInventarioSecundario: 0,
              isDisableSecundario: true,
              medidaMuebleSecundario: 0,
              porcentajeOcupacionSecundario: '0%',
              objetivoSecundario: 0
            })
            this.form.marcas = this.marcas.map(marca => ({ ...marca }))
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    getEjecuciones () {
      Api.get('ejecucionEstrategica')
        .then(response => {
          this.data = response.data
          this.data.map(d => { d.fechaRegistro = d.fechaRegistro.substr(0, 10) })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    editItem (item) {
      this.editedIndex = this.data.indexOf(item)
      this.form = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.clientes.indexOf(item)
      this.$swal({
        icon: 'warning',
        title: '¿Seguro que quiere borrar?',
        text: 'No podrá revertir',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, borrar',
        cancelButtonText: 'cancelar'
      }).then(result => {
        if (result.value) {
          Api.delete('ejecucionEstrategica/' + item._id).then(response => {
            this.$swal('Borrado!', 'Su registro fue borrado.', 'success')
            this.data.splice(index, 1)
          })
        }
      })
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedIndex = -1
        this.form = Object.assign({}, this.defaultForm)
        this.form.marcas = this.marcas.map(marca => ({ ...marca }))
      }, 300)
    },

    showError () {
      this.$swal({
        icon: 'error',
        title: 'Cantidades invalidas o incompletas',
        text: 'Por favor revise las cantidades para guardar'
      })
      return true
    },

    validar () {
      if (this.form.idCliente === '') {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Debe seleccionar un cliente para continuar'
        })
        return true
      }
      let bool = true
      this.form.marcas.forEach(marca => {
        if (!marca.isDisablePrincipal) {
          if (marca.porcentajeOcupacionPrincipal !== '0%' && marca.porcentajeOcupacionPrincipal !== 'error con cantidades') bool = false
          else {
            this.showError()
          }
        }
        if (!marca.isDisableSecundario) {
          if (marca.porcentajeOcupacionSecundario !== '0%' && marca.porcentajeOcupacionSecundario !== 'error con cantidades') bool = false
          else {
            this.showError()
          }
        }
      })
      if (bool) this.showError()
      return bool
    },

    save () {
      if (!this.validar()) {
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => { this.$swal.showLoading() }
        })
        Api.post('ejecucionEstrategica', this.form)
          .then(response => {
            this.$swal({
              icon: 'success',
              title: 'Creación exitosa',
              text: 'Todos los cambios han sido efectuados'
            })
            this.close()
            this.getEjecuciones()
          })
          .catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: 'Error al guardar',
                text: 'Por favor, verifique los datos e intente de nuevo'
              })
            } else if (error.request) {
              this.$swal({
                icon: 'error',
                title: 'Error de red',
                text: 'Por favor verique su conexion de internet'
              })
            } else {
              console.log('Error', error.message)
            }
          })
      }
    }

  }
}
</script>

<style lang='scss'>
.table-marcas {
  .v-text-field__details {
    display: none !important;
  }
}

.header-marca {
  // background: #B2DFDB;
  color: #000 !important;
  font-weight: bold !important;
}

.header-principal {
  background: #BBDEFB;
  color: #000 !important;
  font-weight: bold !important;
  &__left {
    border-left: 1px solid rgba(0,0,0, .3);
  }

  .td-principal {
    background: #E3F2FD;
  }
}

.header-secundario {
  background: #B2DFDB;
  color: #000 !important;
  font-weight: bold !important;
  &__left {
    border-left: 1px solid rgba(0,0,0, .3);
  }
}

.last-child {
  border-top-right-radius: 8px;
}

</style>
